import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';
import adminApi from '../services/adminApi';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.getStats()
      .then(({ data }) => setStats(data.data))
      .catch(() => setStats(null))
      .finally(() => setLoading(false));
  }, []);

  const statCards = [
    { icon: '👥', label: 'Utilisateurs',       value: stats?.total_users ?? '—',    color: '#3B5BA5' },
    { icon: '🆕', label: 'Inscrits ce mois',   value: stats?.new_users_month ?? '—', color: '#E8731A' },
    { icon: '🎓', label: 'Programmes',          value: stats?.total_programs ?? '—',  color: '#D63070' },
    { icon: '📰', label: 'Actualités publiées', value: stats?.total_news ?? '—',      color: '#2D6A4F' },
  ];

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <h1>Tableau de bord</h1>
        <p>Vue d'ensemble de la plateforme BE TALENTED</p>
      </div>

      {loading ? (
        <div className="admin-stats-grid">
          {[1,2,3,4].map(n => (
            <div key={n} className="stat-card" style={{ background: '#f1f5f9', boxShadow: 'none' }}>
              <div style={{ height: 80, borderRadius: 8, background: '#e2e8f0' }} />
            </div>
          ))}
        </div>
      ) : (
        <div className="admin-stats-grid">
          {statCards.map((s) => (
            <div key={s.label} className="stat-card">
              <span className="stat-icon">{s.icon}</span>
              <span className="stat-value" style={{ color: s.color }}>{s.value}</span>
              <span className="stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      )}

      <div className="admin-card">
        <div className="admin-card-header">
          <h2>Accès rapide</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
          {[
            { to: '/admin/programmes',   icon: '🎓', label: 'Gérer les programmes' },
            { to: '/admin/utilisateurs', icon: '👥', label: 'Gérer les utilisateurs' },
            { to: '/admin/actualites',   icon: '📰', label: 'Gérer les actualités' },
          ].map((item) => (
            <Link
              key={item.to}
              to={item.to}
              style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '16px 20px', borderRadius: 12,
                background: '#f8f9fb', textDecoration: 'none',
                color: '#1a1a2e', fontWeight: 600, fontSize: 14,
                transition: 'background 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#eef2ff'}
              onMouseLeave={e => e.currentTarget.style.background = '#f8f9fb'}
            >
              <span style={{ fontSize: 24 }}>{item.icon}</span>
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
